module.exports = __webpack_public_path__ + "img/edge.176a6588.png";